import { a as i, d as e } from "../../index-34b1f277.js";
const t = e({
  color: "primary.700",
  _dark: {
    color: "white"
  }
}), a = e({
  lg: {
    fontSize: "16px",
    lineHeight: "22px",
    letterSpacing: "0",
    "& + p": {
      marginTop: 5
    }
  },
  md: {
    fontSize: "14px",
    lineHeight: "19.3px",
    letterSpacing: "0",
    "& + p": {
      marginTop: 4
    }
  },
  sm: {
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0",
    "& + p": {
      marginTop: "14px"
    }
  },
  xs: {
    fontSize: "10px",
    lineHeight: "15px",
    letterSpacing: "0",
    "& + p": {
      marginTop: 3
    }
  }
}), p = e({
  default: {},
  disabled: {
    color: "primary.300",
    _dark: {
      color: "primary.300"
    }
  }
}), n = i({
  baseStyle: t,
  sizes: a,
  variants: p,
  defaultProps: {
    variant: "default",
    size: "md"
  }
});
export {
  n as ParagraphStyles
};
//# sourceMappingURL=Paragraph.styles.es.js.map
